import debounce from 'lodash.debounce';
import * as constants from './sign-up-constants';
import { path, equals } from 'ramda';

export function updateSignUpProps(payload) {
  return { type: 'UPDATE_SIGN_UP_PROPS', payload };
}

export function clearSignUpStore() {
  return { type: 'CLEAR_SIGNUP_REDUCER' };
}

const getCompanies = debounce((companyName, dispatch, companyType) => {
  return fetch(`/proxy/checkCompanyName/${companyName}/${companyType}`)
  .then(res => res.json())
  .then(res => dispatch({ type: 'COMPANY_NAME_SEARCH_FINISHED', payload: res }))
  .catch(err => console.log(err.stack));
}, 400);

export function checkCompanyName(companyName, companyType) {
  return dispatch => {
    if (companyName) {
      dispatch({ type: 'COMPANY_NAME_SEARCH_STARTING' });
      getCompanies(companyName, dispatch, companyType);
    }
  };
}

export function submitSignUp(credentials) {
  return dispatch => {
    dispatch({ type: 'SIGN_UP_USER_STARTING' });
    return fetch('/proxy/signUpUser', {
      method: 'post',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    })
    .then(res => res.json())
    .then(response => {
      if (response.error) return dispatch({ type: 'SIGN_UP_FAILED', payload: response });
      return dispatch({ type: 'SIGN_UP_USER_FINISHED' });
    })
    .catch(err => {
      console.log(err);
      dispatch({ type: 'SIGN_UP_FAILED' });
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/sign-up/sign-up-actions.js